import { useEffect } from 'react'

type UseSetColorProps = {
	color: string | undefined
	setProductColor: (color: string) => void
}

export const useSetColor = ({ color, setProductColor }: UseSetColorProps) => {
	useEffect(() => {
		if (color) {
			setProductColor(color)
		}
	}, [color])
}
